<script>
import {  common } from '@/mixins/common';
import { GetApiActionWithAuthorizationOnly, PostApiWithAuthorizationAction, PostApiWithAuthorizationActionOnly } from '../../../helpers/apiActions';
import moment from 'moment-timezone';
import AddMoreItemToShowDialog from '../../dialogs/order/AddMoreItemToShowDialog.vue';

export default {
  name: 'ShowList',
  components: {
    AddMoreItemToShowDialog
  },
  props: {},
  data() {
    return {
        tableData: [],
        pagination: {
            page_size: 50,
            total: 1,
            page: 1
        },
        users: [],
        filterAccount: 16,
        filterAccounts: [],
        search: {
            account: ''
        },
        tabCount: 0,
        submittedPercentage: 70,
        displayAddMoreItemDialog: false,
        selectedShow: {},
        columns: [
            {
                key: "title",
                value: 'Name',
                sortable: false,
            },
            {
                key: "startAt",
                value: 'Start Time',
                sortable: false,
            },
            {
                key: "userId",
                value: 'Created By',
                sortable: false,
            },
            {
                key: "submitted",
                value: 'Status',
                sortable: false,
            },
            {
                key: "total_count",
                value: 'Total Count',
                sortable: false,
            },
            {
                key: "actions",
                value: 'Actions',
                sortable: false,
                center: true
            }
        ],
    }
  },
  mixins: [
    common
  ],
  methods: {
    loadPageData (params = {}) {
        let _vm = this
        return GetApiActionWithAuthorizationOnly("admin/products/live-show/get-page-data", params).then(res => {
            _vm.tabCount = res.count
            _vm.users = res.users
            _vm.tableData = res.data
        }).then(() => {
            return GetApiActionWithAuthorizationOnly("admin/products/live-show/get-show-applications")
        }).then(res => {
            _vm.filterAccounts = res.data
        })
    },
    updateCurrentPage(page) {
        this.loadPageData({ page })
        let url = window.location.href.split(/[?#]/)[0];    
        url += (url.indexOf('?') > -1) ? "&" : "?";
        url += "page=" + page
        window.history.replaceState({}, "Cybershop v2", url);
    },
    getSubmittedPourcentage (findShow) {
        return parseInt(((findShow.totalSubmitted * 100) / findShow.totalCount))
    },
    updateNotSubmittedStatus () {
        let _vm = this
        let notSubmittedIds = _vm.tableData.filter(v=>v.submitted==0).map(v=>v.id)
        // eslint-disable-next-line
        console.log(notSubmittedIds)
        if (notSubmittedIds.length > 0) {
            return PostApiWithAuthorizationActionOnly("admin/products/live-show/check-show-status", { ids: notSubmittedIds}).then(res => {
                let shows = res.data
                //
                for (let show of shows) {
                    let findShowIndex = _vm.tableData.findIndex(v=>v.id==show.id)
                    _vm.tableData[findShowIndex].totalSubmitted = show.totalSubmitted
                    _vm.tableData[findShowIndex].submitted = show.submitted
                }
            }); 
        }
        return Promise.resolve([])
    },
    copyAuctionID (show) {
        return GetApiActionWithAuthorizationOnly("admin/products/live-show/get-auctions?id=" + show.id).then(res => {
            window.navigator.clipboard.writeText(res.links);
        });
    },
    endShow (show) {
        if (confirm('Are you sure you want to clear these products?  This will permanently delete them from Ebay.  Do not do this unless the show is over.')) {
            // eslint-disable-next-line
            console.log(show);
        }
    },
    deleteShow (show) {
        if (confirm('Are you sure you want to delete this show ?')) {
            const _vm = this
            return PostApiWithAuthorizationAction("admin/products/live-show/delete-show/" + show.id).then(() => {
                _vm.tableData = _vm.tableData.filter(v=>v.id!=show.id)
            });
        }
    },
    openAddMoreItemDialog (show) {
        const _vm = this
        _vm.selectedShow = show
        _vm.$root.$emit("open-add-more-item-dialog");
    },
    checkAlreadyPassedDate (date) {
        const dateMoment = moment(date*1000)
        const todayMoment = moment()
        //
        return dateMoment.isBefore(todayMoment)
    },
    isRunningShow (timestamp) {
        const dateMoment = moment(timestamp*1000).set({ hour: 18, minute: 0, second: 0 })
        const todayMoment = moment()
        // eslint-disable-next-line
        console.log(dateMoment.format('YYYY-MM-DD HH:mm:ss'))
        //
        return todayMoment.isBefore(dateMoment)
    }
  },
  computed: {},
  mounted () {
    let _vm = this
    _vm.loadPageData()
    setInterval(function () {
        _vm.updateNotSubmittedStatus()
    }, 3000);
  },
  watch: {
    filterAccount: function(appId) {
        this.loadPageData({
            appId
        })
    }
  }
}
</script>
<template>
    <div class="setting-general__content">
        <AddMoreItemToShowDialog :data="selectedShow"/>
        <div class="table-responsive">
            <div class="show-filter mb-2 text-center">
                <el-radio-group v-model="filterAccount">
                    <el-radio-button
                        :label="filterAccount.id"
                        v-for="filterAccount in filterAccounts"
                        :key="filterAccount.id"
                        style="text-transform: uppercase;">{{ filterAccount.liveShowSlug }}</el-radio-button>
                </el-radio-group>
            </div>
            <table
                role="table"
                aria-busy="false"
                aria-colcount="10"
                class="table b-table"
                style="margin: auto"
                >
                    <thead
                    role="rowgroup"
                    class=""
                    style="background-color: #74788d; color: white"
                    >
                    <tr role="row" class="">
                        <th
                        role="columnheader"
                        scope="col"
                        aria-colindex="1"
                        :class="[
                            column.center ? 'text-center': '',
                            'px-4',
                            'text-center'
                        ]"
                        v-for="column in columns"
                        :key="column.key"
                        >
                        <div>{{ column.value }}</div>
                        </th>
                    </tr>
                    </thead>
                    <tbody role="rowgroup">
                    <tr
                        role="row"
                        aria-rowindex="1"
                        class=""
                        v-for="(data) in tableData"
                        :key="data.id"
                    >
                        <!--td
                            aria-colindex="1"
                            role="cell"
                            style="font-size: 14px"
                            class="col-sm">
                        </td-->
                        <td
                            aria-colindex="1"
                            role="cell"
                            class="col-sm font-size-15 font-weight-500">
                            {{ data.title }}
                        </td>
                        <td
                            aria-colindex="1"
                            role="cell"
                            class="col-sm text-center">
                            <div class="font-weight-500 font-size-14">{{ getFormattedData(data.startAt).split(' ')[0] }}</div>
                            <div class="font-size-12 font-weight-500">{{ getFormattedData(data.startAt).split(' ')[1] }} PDT</div>
                        </td>
                        <!--td
                            aria-colindex="1"
                            role="cell"
                            style="font-size: 14px"
                            class="col-sm">
                            {{ getFormattedData(data.endAt).split(' ').join('&nbsp;') }}
                        </td-->
                        <td
                            aria-colindex="1"
                            role="cell"
                            style="font-size: 14px"
                            class="col-sm text-center">
                            {{ data.User.first_name }}&nbsp;{{ data.User.last_name[0] }}.
                        </td>
                        <td
                            aria-colindex="1"
                            role="cell"
                            style="font-size: 14px"
                            class="col-sm">
                        <span v-if="data.submitted">
                            <el-tag
                                :type="checkAlreadyPassedDate(data.startAt) ? (isRunningShow(data.startAt) ? 'warning' : 'danger') : 'primary'"
                                :class="[isRunningShow(data.startAt) && checkAlreadyPassedDate(data.startAt) ? 'blink-animation' : '']"
                                effect="dark"
                                size="small">
                                {{ checkAlreadyPassedDate(data.startAt) ? (isRunningShow(data.startAt) ? "Live" : "Ended") : "Upcoming" }}
                            </el-tag>
                        </span>
                        <el-progress
                            :text-inside="true"
                            :stroke-width="26"
                            :percentage="getSubmittedPourcentage(data)"
                            status="success"
                            v-else/>
                        </td>
                      <td
                            aria-colindex="1"
                            role="cell"
                            style="font-size: 14px"
                            class="col-sm text-center">
                            <el-tag
                                type="primary"
                                effect="dark"
                                size="small"
                                >
                                {{ data.totalCount }}
                            </el-tag>&nbsp;
                            <a
                                href="javascript:;"
                                class="btn btn-danger btn-sm btn-radius"
                                title="Add More Item"
                                @click="openAddMoreItemDialog(data)"
                                >
                                <i class="fas fa-plus"></i>
                            </a>
                        </td>
                        <td
                            aria-colindex="2"
                            role="cell"
                            :class="['text-center', 'px-0', 'col-sm']">
                            <div class="mb-1">
                                <a
                                    href="javascript:;"
                                    class="btn btn-warning"
                                    @click="copyAuctionID(data)"
                                    v-if="data.submitted"
                                    >
                                    <i class="fas fa-copy"></i> Copy AuctionIDs
                                </a>&nbsp;
                                <a
                                    href="javascript:;"
                                    class="btn btn-primary"
                                    @click="viewShow(index)"
                                    >
                                    <i class="fas fa-eye"></i> View Details
                                </a>&nbsp;
                                <a
                                    href="javascript:;"
                                    class="btn btn-danger"
                                    @click="deleteShow(data)"
                                    v-if="!checkAlreadyPassedDate(data.startAt)"
                                    >
                                    <i class="fas fa-pause-circle"></i> End Show
                                </a>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
            <el-pagination
                background
                class="text-center mt-1"
                layout="prev, pager, next"
                :total="pagination.total"
                :page-size="pagination.page_size"
                @current-change="updateCurrentPage"
                :current-page.sync="pagination.page"
                v-if="tableData.length > 0">
            </el-pagination>
        </div>
    </div>
</template>
<style scoped>
.img-thumbnail {
    max-width: 90px !important;
    max-height: 90px !important;
    cursor: pointer;
}
.b-table {
    background-color: rgba(0, 0, 0, 0.05);
    border: 5px solid #5b5f70;
    margin: auto
}
.b-table td {
    padding-top: 6px;
    padding-bottom: 3px;
    vertical-align: middle
}
@media (min-width: 768px) {
    .b-table {
        width: 80%;
    }
}
.el-progress-bar__innerText {
    font-weight: 600 !important;
}
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}
</style>
<style>
.btn-radius {
    border-radius: 30px !important;
}
</style>